"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
//
// Definition of user multi-text select component
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMultiTextSelectComponentParameters = void 0;
exports.UserMultiTextSelectComponentParameters = [
    {
        id: 'options',
        label: 'Selectable Options',
        description: 'Input Param - List of text options the user can filter and select from',
        type: 'list',
        paramType: 'STRING_ARRAY',
        required: true,
    },
    {
        id: 'error',
        label: 'Error Message',
        description: 'Input Param - Message to be displayed when no valid selection is made',
        type: 'string',
        paramType: 'STRING',
        required: false,
    },
    {
        id: 'type',
        label: 'Selection Type',
        description: 'Input Param - Specifies the type of selection (e.g., MULTI or SINGLE)',
        type: 'enum',
        paramType: 'ENUM',
        list: {
            TEXT: 'Text-based input. Full character keyboard.',
            INTEGER: 'Integer-based input. Only digits KB.',
            FLOAT: 'Float-based input. Only digits and decimal (.) KB.',
        },
        required: false,
    },
    {
        id: 'selected',
        label: 'Selected Options',
        description: 'Output Param - List of options selected by the user',
        type: 'output',
        paramType: 'STRING_ARRAY',
        required: true,
    },
];
//# sourceMappingURL=UserMultiTextSelectComponent.js.map